import { useNavigation } from '@react-navigation/native'
import { Text, Center, Box, FlatList } from 'native-base'
import { ListRenderItem, StyleSheet } from 'react-native'

import { Icon } from './Icon'
import { LoadingState } from './LoadingState'
import { PurchaseHistoryTile, PURCHASE_TILE_HEIGHT } from './PurchaseHistoryTile'
import { Spacer } from './atoms/Spacer'

import { useCallback, useMemo, useTranslation } from '~hooks'
import { PurchaseHistoryItem } from '~types/user'
import { noop } from '~utils'

export const PurchaseHistoryList = ({
  data,
  onRefresh = noop,
  refreshing = false,
  isLoading = false,
  emptyMessageKey = 'common.no_purchase_history',
}: {
  data?: PurchaseHistoryItem[]
  onRefresh: () => void
  refreshing: boolean
  isLoading?: boolean
  emptyMessageKey?: string
}) => {
  const { t } = useTranslation()
  const { navigate } = useNavigation<any>()
  const keyExtractor = useCallback((item: PurchaseHistoryItem) => item.id, [])

  const purchaseHistory = data || []

  const handleItemPress = useCallback(
    (offerId?: string) => {
      if (offerId) {
        navigate('OfferDetails', { offerId })
      }
    },
    [navigate]
  )

  const renderItem: ListRenderItem<PurchaseHistoryItem> = useCallback(
    ({ item }: { item: PurchaseHistoryItem }) => {
      const handlePress = () => handleItemPress(item.offerId)
      return (
        <Box px="4">
          <PurchaseHistoryTile {...item} onPress={handlePress} />
        </Box>
      )
    },
    [handleItemPress]
  )

  const ListEmptyComponent = useMemo(() => {
    if (isLoading) {
      return <LoadingState />
    }
    return (
      <Center flexGrow={1}>
        <Icon name="vip-diamond-line" size={50} color="inactive" />
        <Text bold mt="4" color="inactive" fontSize="2xl">
          {t(emptyMessageKey)}
        </Text>
      </Center>
    )
  }, [isLoading, t, emptyMessageKey])

  const spacerItem = useCallback(() => <Spacer y="2" />, [])

  return (
    <FlatList
      contentContainerStyle={styles.flatList}
      ListEmptyComponent={ListEmptyComponent}
      data={purchaseHistory}
      keyExtractor={keyExtractor}
      ItemSeparatorComponent={spacerItem}
      onRefresh={onRefresh}
      refreshing={refreshing}
      renderItem={renderItem}
      showsVerticalScrollIndicator={false}
    />
  )
}
const styles = StyleSheet.create({
  flatList: {
    flexGrow: 1,
    paddingBottom: PURCHASE_TILE_HEIGHT / 2,
    paddingTop: 16,
  },
})

